import { IAppTheme } from "../../types";

export type TToggleSize = "sm" | "md";

type TToggleStyles = {
    borderColor: string;
    backgroundColor: string;
    sliderBackgroundColor: string;
};

type TToggleStylesMap = TToggleStyles & {
    hover: TToggleStyles;
    disabled: TToggleStyles;
    focus: TToggleStyles & {
        ringColor: string;
    };
    width: string;
    height: string;
    borderRadius: string;
    sliderSize: string;
    labelGap: string;
};

export const getToggleStyles = (theme: IAppTheme, size: TToggleSize, checked: boolean): TToggleStylesMap => {
    let styles = {};

    switch (size) {
        case "sm":
            styles = {
                ...styles,
                width: "36px",
                height: "20px",
                borderRadius: "12px",
                sliderSize: "16px",
                labelGap: "8px"
            };
            break;
        case "md":
            styles = {
                ...styles,
                width: "44px",
                height: "24px",
                borderRadius: "12px",
                sliderSize: "20px",
                labelGap: "12px"
            };
            break;
        default:
            throw new Error(`Unknown toggle size: ${size}`);
    }

    styles = {
        ...styles,
        ...(checked
            ? {
                  borderColor: theme.v2.colors["primary-700"],
                  backgroundColor: theme.v2.colors["surface-800"],
                  sliderBackgroundColor: theme.v2.colors["background-primary-base"],
                  hover: {
                      borderColor: theme.v2.colors["primary-500"],
                      backgroundColor: theme.v2.colors["primary-200"],
                      sliderBackgroundColor: theme.v2.colors["background-primary-base"]
                  },
                  disabled: {
                      borderColor: theme.v2.colors["surface-100"],
                      backgroundColor: theme.v2.colors["surface-50"],
                      sliderBackgroundColor: theme.v2.colors["surface-200"]
                  },
                  focus: {
                      borderColor: theme.v2.colors["primary-700"],
                      backgroundColor: theme.v2.colors["surface-800"],
                      sliderBackgroundColor: theme.v2.colors["surface-base"],
                      ringColor: theme.v2.colors["surface-100"]
                  }
              }
            : {
                  borderColor: theme.v2.colors["border-primary-100"],
                  backgroundColor: theme.v2.colors["background-primary-base"],
                  sliderBackgroundColor: theme.v2.colors["surface-100"],
                  hover: {
                      borderColor: theme.v2.colors["border-primary-300"],
                      backgroundColor: theme.v2.colors["background-primary-base"],
                      sliderBackgroundColor: theme.v2.colors["surface-300"]
                  },
                  disabled: {
                      borderColor: theme.v2.colors["border-primary-100"],
                      backgroundColor: theme.v2.colors["surface-50"],
                      sliderBackgroundColor: theme.v2.colors["surface-200"]
                  },
                  focus: {
                      borderColor: theme.v2.colors["primary-300"],
                      backgroundColor: theme.v2.colors["surface-base"],
                      sliderBackgroundColor: theme.v2.colors["surface-300"],
                      ringColor: theme.v2.colors["surface-100"]
                  }
              })
    };

    return styles as TToggleStylesMap;
};
